const weekDayName = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];
export const getWeekDayName = (date = new Date()) => {
  const weekDay = date.getDay();
  return weekDayName[weekDay];
};

export const getReadableDate = (date = new Date()) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${String(day).padStart(2, "0")}-${String(month).padStart(
    2,
    "0"
  )}-${year}`;
};

export const dateWithoutTimezone = (date = new Date()) => {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
};
